import React, { createContext, useState, useEffect, useContext } from 'react';

import { useSelector } from 'react-redux';

import { cloudloyalty } from 'Services/Apis/clients';

const HierarchyProductsLocalStorageContext = createContext(null);

export const HierarchyProductsLocalStorageProvider = ({ children }) => {
    const [hierarchyProductsLocalStorageValue, setHierarchyLocalStorageValue] =
        useState({
            products: JSON.parse((localStorage.getItem('Premmiar@:products')))?.length
                ? JSON.parse((localStorage.getItem('Premmiar@:products')))
                : []
        })

    const {
        user
    } = useSelector(state => state.oidc);

    const {
        email
      } = useSelector(state => state.Participants);

    const addItemToCart = async (data) => {
        try {
          const response = await cloudloyalty(user).post(`v1/carts/me/items`, data);
          return { error: false, data: { ...response.data } };
        } catch (error) {
          if (error.response.data.messages[0].description.includes('e-mail')) {
            console.log('addItemToCart error XXXXXXX ', error);
          } else {
            notification.error({
              message: error.response.data.messages[0].description.inclu,
            });
          }
          throw error;
        }
    };

    const handleAddCart = async (product) => {
        const data = {
          email: email.value,
          vendorId: product.vendorId,
          sku: product.sku,
          quantity: product.quantity,
        };
    
        try {
          await addItemToCart(data);
        } catch (error) {
          throw error;
        }
    };

    const getCart = async () => {
        try {
            const response = await cloudloyalty(user).get(`v1/carts/me`);
            return { error: false, data: { ...response.data } };
        } catch (error) {
            console.log('getCart error XXXXXXX ', error);
            throw error;
        }
    };

    const clearCart = async (sku) => {
        try {
            await cloudloyalty(user).delete(
            `v1/carts/me/items/${sku}`
            );
            return 'success';
        } catch (error) {
            console.log('clearCart error XXXXXXX ', error);
            throw error;
        }
    };

    const handleAddLocalStorageProduct = async (product) => {
        let listProductsStorage = hierarchyProductsLocalStorageValue?.products
            ?.length
            ? hierarchyProductsLocalStorageValue?.products
            : [];
        try {
            if (listProductsStorage?.length === 0) {
            const cart = await getCart();
    
            if (cart.data !== null) {
                const cartItems = cart.data.items;
    
                if (cartItems.length > 0) {
                for (const item of cartItems) {
                    await clearCart(item.sku);
                }
                }
            }
            }
    
            if (listProductsStorage?.find((p) => p.sku === product.sku)) {
            const itemToUpdate = listProductsStorage.find(
                (item) => item.sku === product.sku
            );
            const updatedItem = itemToUpdate
                ? { ...itemToUpdate, quantity: itemToUpdate.quantity + 1 }
                : null;
            const filteredArray = listProductsStorage.filter(
                (item) => item.sku !== product.sku
            );
    
            setHierarchyLocalStorageValue({
                products: [...filteredArray, updatedItem],
            });
            } else {
            listProductsStorage?.push(product);
            setHierarchyLocalStorageValue({ products: listProductsStorage });
            }
            const productIsGeneric = product.sku.includes('-PGS');
    
            if (!productIsGeneric) {
            await handleAddCart(product);
            }
        } catch (err) {
            throw err;
        }
    };

    useEffect(() => {
        localStorage.setItem('Premmiar@:products', JSON.stringify(hierarchyProductsLocalStorageValue.products))

    }, [hierarchyProductsLocalStorageValue])

    return (
        <HierarchyProductsLocalStorageContext.Provider value={{ hierarchyProductsLocalStorageValue, setHierarchyLocalStorageValue, handleAddLocalStorageProduct }}>
            {children}
        </HierarchyProductsLocalStorageContext.Provider>
    );
};

export const useHierarchyProductsLocalStorageContext = () => useContext(HierarchyProductsLocalStorageContext);